import { Component, OnInit, Input } from '@angular/core';
import { PropertyData } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-texthistorique',
  templateUrl: './texthistorique.component.html',
  styleUrls: ['./texthistorique.component.css']
})

export class TexthistoriqueComponent extends BaseAddOnComponent implements OnInit {

  @Input('input') input: PropertyData;

  constructor() { super(); }

  ngOnInit(): void { }
}
